import {Component, OnInit} from '@angular/core';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {RedirectService} from '../../../../general/services/redirect.service';
import {Router} from '@angular/router';
import {PpsService} from '../board/pps.service';
import {CoreService, ProleisObject} from 'proleis-rest-client';
import {debounceTime, exhaustMap, of, tap} from 'rxjs';
import {FormControl} from '@angular/forms';
import {startWith} from 'rxjs/operators';
import {NotificationService} from '../../../../../p4m/notification.service';

export const TAB_INDEX = 'p4m-scan-part-tab';

@Component({
  selector: 'p4m-scan-part',
  templateUrl: 'scan-part.component.html',
})
export class ScanPartComponent implements OnInit {
  scannedObject: ProleisObject;
  objectId: string;
  selectedIndex: number;
  idInputFormControl: FormControl;

  constructor(
    private redirectService: RedirectService,
    private router: Router,
    private ppsService: PpsService,
    private coreService: CoreService,
    private notificationService: NotificationService,
  ) {}

  ngOnInit() {
    this.initIdInput();
    this.redirectService.loadTypes();
    if (localStorage.getItem(TAB_INDEX)) {
      this.selectedIndex = Number(localStorage.getItem(TAB_INDEX));
    }
  }

  initIdInput() {
    this.idInputFormControl = new FormControl<string>('');
    this.idInputFormControl.valueChanges
      .pipe(
        debounceTime(500),
        startWith(undefined),
        exhaustMap((id) => {
          if (id) {
            return this.coreService.getObjectById<ProleisObject>(
              id,
              'TYP_GUID=TYP_ID.GUID',
            );
          } else {
            return of(undefined);
          }
        }),
        tap((obj: ProleisObject) => {
          if (obj) {
            this.scannedObject = obj;
            this.objectId = obj?.OBJECT_ID;
            this.redirect();
          }
        }),
      )
      .subscribe();
  }

  onCodeScanned(event) {
    if (event) {
      this.objectId = event;
      this.coreService
        .getObjectById<ProleisObject>(this.objectId, 'TYP_GUID=TYP_ID.GUID')
        .subscribe((object) => {
          this.scannedObject = object;
          this.redirect();
        });
    }
  }

  onTabChanged(event: MatTabChangeEvent) {
    localStorage.setItem(TAB_INDEX, event.index.toString());
    this.selectedIndex = event.index;
  }

  redirect() {
    if (
      !this.scannedObject &&
      this.idInputFormControl.getRawValue().length > 0
    ) {
      this.notificationService.showNotification(
        `${this.idInputFormControl.getRawValue()} ist kein gültiges Objekt`,
        'error',
      );
    } else {
      this.ppsService.isTask(this.objectId).subscribe((isTask) => {
        if (isTask) {
          this.redirectService.redirectToInfoPanel(this.objectId);
        } else {
          if (!this.scannedObject) {
            this.notificationService.showNotification(
              `Zu ${this.objectId} wurde kein Objekt gefunden!`,
              'warning',
            );
          }

          if (this.redirectService.validTypeGuid(this.scannedObject?.TYP_GUID)) {
            const route = `/planning/${this.objectId}/tasks`;
            this.router.navigate([route]).then();
          } else {
            this.notificationService.showNotification(
              `${this.scannedObject.TEXT} ist kein gültiges Objekt für Bauteilscan`,
              'warning',
            );
          }
        }
      });
    }
  }
}
